<template>
  <div>
    <div class="modal-card">
      <header class="modal-card-head">
          <h4 class="modal-card-title is-size-4 has-text-black-bis
          is-capitalized has-text-weight-bold">
            Source Production Order
           </h4>
          <button class="button has-text-weight-bold has-background-black-bis has-text-white is-size-4"
            @click="openSourceOrder">
            View Full Order
          </button>
      </header>
      <section class="modal-card-body is-marginless is-visible">
        <div class="has-background-white" v-if="cardLoaded">
          <div class="header-stripe">

          </div>
          <div class="column primary-card-info pl-0">
            <div class="columns">
              <div class="column is-flex">
                <span class="has-text-white ml-0 mr-3 image is-48x48  mf-fm-background mr-0 has-text-centered is-flex is-align-items-center is-justify-content-center">
                  <i class="icon-productionorder"></i>
                </span>
                <div class="has-text-black-bis">
                  <h3 class="is-italic has-text-weight-semibold mb-2">Source Production Order</h3>
                  <span class="has-text-weight-normal">{{ order?.name }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="column secondary-card-info">
            <div class="columns is-multiline">
              <div class="column has-text-dark is-6">
                <div class="has-text-black-bis is-italic is-size-3 label is-flex">
                 <span class="is-pulled-left mr-2">Owner:</span><span class="text-overflow has-text-weight-normal">{{ order.owner?.user?.name }}</span>
                </div>
                <div class="is-divider mt-4 mb-2"></div>
                <label class="has-text-black-bis is-italic is-size-3 label">
                  Production Location: <span class="has-text-weight-normal">{{ order.manager?.location?.name }}</span>
                </label>
              </div>
              <div class="column has-text-dark">
                <div class="has-text-black-bis is-italic is-size-3 is-flex">
                  <span class="label">Stage: </span>
                  <span> <stage-field
                      :value="order.stage"
                      >
                    </stage-field></span>
                   
                  </div>
                <div class="is-divider my-2"></div>
                <label class="has-text-black-bis is-italic is-size-3 label">
                  Status: <span class="has-text-weight-normal ml-2">{{ order.status }}</span>
                </label>
              </div>
              <div class="column has-text-black-bis is-flex has-text-black-bis is-size-3">
               
                  <span class="label is-italic mr-2">Onsite: </span>
                  <span><field-date
                    :isEdit="false"
                    :item="order"
                    :input-props="{kind: 'deliver',
                      pos: 'bottom-left'}"
                  ></field-date></span>              
              </div>
            </div>
          </div>
        </div>>
        <div class="my-2">
          <mf-table
          v-if="cardLoaded"
          :tableProps="tableProps"
          :loadData="getLoadData()"
          ref="srcTable"
          :apiMode="true"
          :hideGutter="true">
          </mf-table>
        </div>
      </section>
      <footer class="modal-card-foot is-justify-content-flex-end has-background-white">
        <div>
          <button
            class="button has-background-black-bis"
            @click="cancel()">
            Done
          </button>
        </div>
      </footer>
    </div>
    <o-loading
      :full-page="true"
      :active="isLoading"
      :can-cancel="true"
    ></o-loading>
  </div>
</template>

<script>

import { computed, defineComponent, inject, onBeforeMount, onMounted, reactive, ref, toRefs } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { get } from "lodash";
import MfTable from '@/components/table-fields/MfTable.vue';
import SearchBar from '@/components/SearchBar.vue';
import sourceOrderCols from '@/components/table-cols/sourceOrderCols';
import ProductionManager from '@/models/ProductionManager'
import MfDetailRow from '@/components/table-fields/MfDetailRow.vue';
import StageField from '@/components/fields/StageField.vue';
import MaterialManager from '@/models/MaterialManager';

export default defineComponent({
  name: 'ItemDeliveries',
  props: [
    'rowData',
    'project',
  ],
  components: {
    MfTable,
    'search-bar': SearchBar,
    'mf-detail-row': MfDetailRow,
    StageField,
  },

  setup(props, { emit }) {
    let { rowData } = props;
    const store = useStore();
    const router = useRouter();
    const srcTable = ref(null);

    const tableProps = sourceOrderCols;

    const state = reactive({
      shouldEmit: true,
      isLoading: false,
      order: {},
      cardLoaded: false,
      srcItem: [],
    })
    

    const loadAsyncData = async () => {
      for (const item of state.order.items) {
        if (rowData._id === item._id) state.srcItem.push(item);
      }
      state.srcItem = state.srcItem.filter((item) => !item.archived?.value);
      return { data: state.srcItem, total: state.srcItem.length };
    };

    const loadData = () => {
      let items = get(state.order, 'items', []);
      return items;
    }

    const getLoadData = () => {
      if (getApiMode()) return loadAsyncData;
      return loadData;
    };

    const loadCard = async () => {
      try {
        state.isLoading = true;
        if (rowData.source.kind === 'Sourcing') {
            state.order = await MaterialManager.getOne({
            cardId: rowData.source._id,
            projectId: props.project._id,
          })
        } else {
          state.order = await ProductionManager.get({
            orderId: rowData.source._id,
            projectId: props.project._id,
          })
        }
      } catch (error) {
        
      } finally {
        state.isLoading = false;
      }
    }

    const cancel = (doRefresh = false) => {
      emit('close', { doRefresh });
    };

    const getApiMode = () => {
      if (store.state.activeScreen === 'shipping-card-edit') { return true; }
      return tableProps?.isCardView;
    };

    const openSourceOrder = () => {
      router.push({
        name: rowData.source.kind === 'Sourcing' ? 'material-edit' : 'manager-edit',
        params: { projectId: state.order.project._id, cardId: state.order.id, stage: state.order.stage},
      });
    }

    onBeforeMount( async () => {
      await loadCard();
      state.cardLoaded = true;
    })

    return {
      ...toRefs(state),
      srcTable,
      cancel,
      tableProps,
      loadCard,
      getLoadData,
      loadAsyncData,
      openSourceOrder,
    }
  }
})
</script>
<style scoped>
.modal-card-head {
  background-color: #fff;
  border-bottom: 0 !important;
}
.icon-productionorder {
  font-size: 40px !important;
}
.modal-card-body {
  border-top: 16px solid #2d5261;
}
.modal-card-foot {
  border-top: 1px solid #84888c;
}
::v-deep(.modal-card-body .mf-table .o-table__wrapper) {
  min-height: 37vh !important;
  max-height: 37vh !important;
}
::v-deep(.modal-card-body) {
  min-height: 440px !important;
}
</style>